import React, { useState } from 'react';
import LineupsTab from './LineupsTab';
import StatsTab from './StatsTab';
import EventsTab from './EventsTab';
import H2HTab from './H2HTab';
import StandingsTab from './StandingsTab';
import PredictionPoll from './PredictionPoll';
import Icon from '../icons/Icon';
import './MatchTabs.css';

const TABS = [
  { id: 'events',    label: 'Events',    icon: 'events' },
  { id: 'lineups',   label: 'Lineups',   icon: 'lineups' },
  { id: 'stats',     label: 'Stats',     icon: 'stats' },
  { id: 'h2h',       label: 'H2H',       icon: 'h2h' },
  { id: 'standings', label: 'Standings', icon: 'standings' },
];

export default function MatchTabs({ match }) {
  const [active, setActive] = useState('events');

  return (
    <div className="match-tabs">
      <div className="match-tabs-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`match-tab-btn ${active === tab.id ? 'active' : ''}`}
            onClick={() => setActive(tab.id)}
          >
            <Icon name={tab.icon} size={16} />
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="match-tab-content">
        {active === 'events'    && <EventsTab match={match} />}
        {active === 'lineups'   && <LineupsTab match={match} />}
        {active === 'stats'     && <StatsTab match={match} />}
        {active === 'h2h'       && <H2HTab match={match} />}
        {active === 'standings' && <StandingsTab match={match} />}
      </div>

      <PredictionPoll match={match} />
    </div>
  );
}
